module.exports = __webpack_public_path__ + "static/media/not-sure-all.9c6a0cd3.png";